<template>
  <v-tabs
    v-model="currentTab"
    hide-slider
    class="guides-tabs"
  >
    <v-tab
      v-for="(tab, index) in tabs"
      :key="index"
      :model-value="index"
      class="guides-tabs-item"
    >
      {{ tab.name }}
      <span
        v-if="tab.comingSoon"
        class="guides-tabs-coming-soon"
      >
        Coming Soon
      </span>
    </v-tab>
  </v-tabs>

  <v-window
    v-model="currentTab"
    continuous
    class="guides-tab"
  >
    <Transition
      v-for="({ items, comingSoon }, index) in tabs"
      :key="index"
      name="tab-fade"
    >
      <v-window-item
        :class="['guides-tab-content', `${itemsPerRow}-tab-items-per-row`]"
        :transition="false"
        :reverse-transition="false"
      >
        <slot
          name="tab-content"
          :items="items"
          :coming-soon="comingSoon"
        >
          <NoEditorWrapper
            v-for="(item, idx) in items"
            :key="idx"
          >
            <GuidesCard
              :guide-item="item"
              :coming-soon="comingSoon"
              @submit="$emit('submit', $event)"
            />
          </NoEditorWrapper>
        </slot>
      </v-window-item>
    </Transition>
  </v-window>
</template>

<script setup>
import GuidesCard from '@/components/settings/components/GuidesCard.vue';
import NoEditorWrapper from '@/components/editor/NoEditorWrapper.vue';

defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  itemsPerRow: {
    type: String,
    default: 'three',
  },
});

defineEmits(['submit']);

const currentTab = defineModel();
</script>

<style scoped lang="less">
.guides-tabs-item {
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  padding: 0 24px;
  background: @grey-400;
  color: @text-darkest;

  &[aria-selected="true"] {
    color: @text-brand;
    background: @white;
  }

  &:not(:last-child) {
    border-right: 1px solid @stroke-default;
  }

  &:first-child {
    border-top-left-radius: 10px;
  }

  &:last-child {
    border-top-right-radius: 10px;
  }

  .guides-tabs-coming-soon {
    font-size: 12px;
    font-weight: 400;
    color: @white;
    background: @bg-brand-default;
    padding: 8px;
    border-radius: 16px;
    margin-left: 8px;
  }
}

.guides-tab {
  background: @white;
  padding: 24px;
  border-radius: 0 10px 10px 10px;
}

.guides-tab-content {
  display: grid;
  gap: 24px;
  background: @white;

  &.three-tab-items-per-row {
    grid-template-columns: repeat(3, 1fr);
  }

  &.two-tab-items-per-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

.tab-fade {
  &-enter {
    opacity: 0;
    transition: all 500ms ease;
  }

  &-enter-to {
    opacity: 1;
    transition: all 500ms ease;
  }

  &-leave, &-leave-active {
    position: absolute;
    top: 0;
  }

  &-leave-to {
    position: absolute;
    opacity: 0;
    transition: all 0ms ease;
  }
}
</style>
